module.exports = __webpack_public_path__ + "static/media/IMG_1124.85a7606c.jpg";